import React, { useState, useEffect } from "react";
import { Image, Row, Col, Button, Modal, Form, Card } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as PrintingProgressItemStyles from "../../styles/order/printingProgressItem";

function PrintProgressItem(props) {
    return (
        <div>
            <div style={PrintingProgressItemStyles.body}>
                <Row>
                    <Col md="auto">
                        <Image
                            src={`/content/3dPrintingShop/products/${props.mainItem.itemDetails.uuid.toString()}/${
                                props.mainItem.itemDetails.mainImage
                            }`}
                            style={PrintingProgressItemStyles.image}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <strong>Name:</strong> {props.mainItem.itemDetails.title} <br />
                                        {props.mainItem.designElement != "---" && (
                                            <div>
                                                <strong>Design Element:</strong> {props.mainItem.designElement} <br />
                                                <Button>Upload Design</Button>
                                            </div>
                                        )}
                                    </Col>
                                    <Col>
                                        {props.mainItem.customItem == "true" && (
                                            <div>
                                                <strong style={PrintingProgressItemStyles.customTitle}>Customisation</strong>
                                                {props.mainItem.itemDetails.customItems.map((field, index) => {
                                                    if (field.type == "text" || field.type == "dColour") {
                                                        return (
                                                            <div key={index}>
                                                                {field.fieldName}: {field.fieldValue}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                                {props.mainItem.itemDetails.customColours && (
                                                    <div>
                                                        <br />
                                                        <strong>Colours:</strong>
                                                        {props.mainItem.itemDetails.customItems.map((field, index) => {
                                                            if (field.type == "colour") {
                                                                return (
                                                                    <div key={index}>
                                                                        {field.fieldName}: {field.fieldValue}
                                                                    </div>
                                                                );
                                                            }
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {props.mainItem.quantity == 1 ? (
                                            <Item item={props.mainItem} quantityOfProducts={false} reload={props.reload} />
                                        ) : (
                                            <div>
                                                <Item
                                                    item={props.mainItem}
                                                    quantityOfProducts={true}
                                                    productIndex={"1"}
                                                    totalProducts={props.mainItem.quantity}
                                                    reload={props.reload}
                                                />
                                                <hr />
                                                {props.extraItems.map((item, index) => {
                                                    return (
                                                        <Item
                                                            key={index}
                                                            item={item}
                                                            quantityOfProducts={true}
                                                            productIndex={index + 2}
                                                            totalProducts={props.mainItem.quantity}
                                                            reload={props.reload}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <br />
        </div>
    );
}

function Item(props) {
    const [transactionType, setTrasactionType] = useState("");

    const [modal, setModal] = useState({
        title: "",
        message: "",
        show: false
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, show: false };
        });
    }

    const messageLogDefaults = {
        open: false,
        itemUUID: "",
        message: "",
        countTotal: 200
    };

    const [messageLog, setMessageLog] = useState(messageLogDefaults);

    function handleLogMessageClose() {
        setMessageLog(messageLogDefaults);
    }

    const [messageLogHistory, setMessageLogHistory] = useState({
        open: false,
        messages: []
    });

    function handleMessageHistoryClose() {
        setMessageLogHistory({ open: false, messages: [] });
    }

    useEffect(() => {
        // console.log(props.item.priceStatus);
        if (props.item.priceStatus == "dp") {
            setTrasactionType("Deposit");
            if (props.item.depositRequested == "true") {
                setTrasactionType("Deposit (Full amount requested)");
            }
        } else {
            setTrasactionType("Full Price");
        }
    }, [props]);

    const [depositModal, setDepositModal] = useState({
        open: false
    });

    function handleDepositModalClose() {
        setDepositModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleIncreaseModels(uuid) {
        const data = { itemID: uuid, direction: "increase" };
        Axios.post("/pods/3dPrintingShop/orders/alterModelsValue", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "dpNotFullyPaid") {
                    setModal({
                        title: "Deposit Item",
                        message: "The customer has not paid the full amount yet so you cannot build any more models",
                        show: true
                    });
                    props.reload();
                }
                if (data.error == "dpFullyPaid") {
                    props.reload();
                }
                if (data.error == "null") {
                    const trueHalf = parseInt(props.item.totalModels) / 2;
                    const halfPlus = trueHalf + 1;
                    const half = parseInt(props.item.totalModels) - parseInt(data.totalBuilt);
                    if (trueHalf >= half) {
                        if (half >= halfPlus) {
                            console.log("Checks if it have been paid");
                        }
                        if (props.item.priceStatus == "dp") {
                            setDepositModal((prevState) => {
                                return { ...prevState, open: true };
                            });
                        }
                    }

                    props.reload();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleDecreaseModels(uuid) {
        const data = { itemID: uuid, direction: "decrease" };
        Axios.post("/pods/3dPrintingShop/orders/alterModelsValue", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    props.reload();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleActiveFullPrice(uuid) {
        const data = { uuid: uuid };
        Axios.post("/pods/3dPrintingShop/orders/ActivateFullPriceOnDespit", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setDepositModal((prevState) => {
                        return { ...prevState, open: false };
                    });
                    console.log("test reload");
                    props.reload();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenLogMessage(itemUUID) {
        setMessageLog((prevState) => {
            return { ...prevState, itemUUID: itemUUID, open: true };
        });
    }

    function handleLogMessageTextChange(event) {
        const { value } = event.target;

        setMessageLog((prevState) => {
            return { ...prevState, message: value };
        });
    }

    function handleLogMessageSendAMessage() {
        const data = { itemUUID: messageLog.itemUUID, message: messageLog.message };
        Axios.post("/pods/3dPrintingShop/orders/logAMessage", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setMessageLog(messageLogDefaults);
                    props.reload();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenMessageHistory(itemUUID) {
        const data = { itemUUID: itemUUID };
        Axios.post("/pods/3dPrintingShop/orders/getItemMessageHistory", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setMessageLogHistory({ open: true, messages: data.messages });
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <Row>
                <Col>
                    {props.quantityOfProducts && (
                        <Row>
                            <Col style={PrintingProgressItemStyles.columnRight}>
                                <strong>
                                    {props.productIndex} of {props.totalProducts}
                                </strong>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col>
                            <strong>Transaction Type: </strong>
                            {transactionType}
                        </Col>
                    </Row>
                    <Row style={PrintingProgressItemStyles.modelAmounts}>
                        <Col>
                            <strong>Total Models:</strong> {props.item.totalModels}
                        </Col>
                        <Col>
                            <strong>Models Built:</strong> {props.item.totalBuilt}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={PrintingProgressItemStyles.progressArea}>
                                <div style={PrintingProgressItemStyles.progressBarBack}>
                                    <div
                                        style={{
                                            ...PrintingProgressItemStyles.progressBarFront,
                                            width: `${props.item.progress}%`
                                        }}
                                    ></div>
                                </div>
                                {props.item.progress}%
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <div style={PrintingProgressItemStyles.printedControls}>
                        Printed Models:
                        <Button onClick={handleDecreaseModels.bind(this, props.item.uuid)}>-</Button>
                        <Button onClick={handleIncreaseModels.bind(this, props.item.uuid)}>+</Button>
                    </div>
                    <div>
                        <Button onClick={handleOpenLogMessage.bind(this, props.item.uuid)}>Log a message</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {props.item.latestMessage != "" && (
                        <div>
                            <strong>Latest Message:</strong> {props.item.latestMessage}
                        </div>
                    )}
                </Col>
            </Row>
            <Modal show={depositModal.open} onHide={handleDepositModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Deposit Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to activiate the remaining amount on this model?</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleDepositModalClose}>No</Button>
                    <Button onClick={handleActiveFullPrice.bind(this, props.item.uuid)}>Yes</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modal.show} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={messageLog.open} onHide={handleLogMessageClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Log Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Send a message about this item: <br />
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={messageLog.message}
                        onChange={handleLogMessageTextChange}
                        maxLength={messageLog.countTotal}
                    />
                    <div style={PrintingProgressItemStyles.messageLogCounter}>{messageLog.countTotal - messageLog.message.length}</div>
                    <hr />
                    <Row>
                        <Col>
                            <Button onClick={handleOpenMessageHistory.bind(this, props.item.uuid)}>See History</Button>
                        </Col>
                        <Col style={PrintingProgressItemStyles.columnRight}>
                            <Button onClick={handleLogMessageClose}>Close</Button>
                            <Button onClick={handleLogMessageSendAMessage}>Send</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={messageLogHistory.open} onHide={handleMessageHistoryClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Message History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {messageLogHistory.messages.map((message, index) => {
                        return (
                            <div key={index}>
                                <Card>
                                    <Card.Body>
                                        <strong>Date:</strong> {message.date}
                                        <br />
                                        <strong>Message:</strong> {message.message}
                                    </Card.Body>
                                </Card>
                                <br />
                            </div>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleMessageHistoryClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default PrintProgressItem;
